<template>
  <div class="comment">
    <h4 class="section-title">
      <span>Сэтгэгдэл ({{ commentCount }})</span>
    </h4>

    <div class="comment__form">
      <textarea
        v-model="commentBody"
        rows="3"
        class="comment__form-message"
        placeholder="Сэтгэгдлээ бичнэ үү.."
      ></textarea>
      <p class="comment__warning">
        АНХААРУУЛГА: Уншигчдын бичсэн сэтгэгдэлд Zindaa.mn хариуцлага хүлээхгүй
        болно. Манай сайт ХХЗХ-ны журмын дагуу зүй зохисгүй зарим үг, хэллэгийг
        хязгаарласан тул Та сэтгэгдэл бичихдээ бусдын эрх ашгийг хүндэтгэн үзнэ
        үү. Хэм хэмжээ зөрчсөн сэтгэгдлийг админ устгах эрхтэй.
      </p>

      <div class="comment__alert" v-if="commentSendStatus != ''">
        {{ commentSendStatus }}
      </div>

      <div class="text-right">
        <b-btn class="comment__form-send" variant="primary" @click="sendComment"
          >Илгээх</b-btn
        >
      </div>
    </div>

    <div class="comment__items">
      <div
        class="comment__item"
        v-for="comment in comments"
        :key="'other-' + comment.id"
      >
        <div class="comment__item-head">
          <span>IP: {{ comment.ip }}</span
          ><span v-html="comment.fdate"></span>
        </div>
        <p class="comment__item-body">{{ comment.comment }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { putComment } from "../../api/";
export default {
  data() {
    return {
      item: this.$parent.item,
      comments: this.$parent.item.comments,
      commentCount: this.$parent.item.comment_count,
      commentBody: "",
      commentSendStatus: ""
    };
  },
  name: "Comment",
  methods: {
    sendComment() {
      putComment(this.item.id, this.commentBody).then(response => {
        if (response.data.status === "success") {
          this.comments.unshift(response.data.data);
          this.commentBody = "";
          this.commentSendStatus = "";
        } else {
          this.commentSendStatus = response.data.message;
          setTimeout(() => {
            this.commentSendStatus = "";
          }, 3000);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/boots/custom_bootstrap";
.comment {
  &__warning {
    font-family: $slab;
    font-style: italic;
    line-height: 1.2;
    font-size: 0.8em;
    color: #999;
  }

  &__alert {
    border: 1px solid $danger;
    color: $danger;
    padding: 10px;
    margin-bottom: 20px;
    border-radius: 3px;
    font-size: 0.9em;
  }

  &__form {
    &-message {
      display: block;
      width: 100%;
      border-bottom: 2px solid #ddd;
      resize: none;
      margin: 10px 0;
      padding: 5px 8px;
      font-size: 0.9em;
      transition: all 0.5s;
    }

    &-message:focus {
      border-bottom: 2px solid $primary;
    }

    &-send {
      border-radius: 0;
      box-shadow: none !important;
    }
  }

  &__item {
    font-size: 0.9em;
    border-top: 1px solid #ddd;
    margin: 10px 0;
    padding: 10px;

    &-head {
      color: #666;
      span:not(:last-child) {
        display: inline-block;
        padding: 0 10px;
        margin-right: 10px;
        border-right: 1px solid#ddd;
      }
    }

    &-body {
      padding: 0;
      margin: 0;
    }
  }
}
</style>
